var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCr = function SvgCr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0000b4",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 75.428h640v322.285H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d90000",
    d: "M0 157.716h640V315.43H0z"
  }))));
};
export default __webpack_public_path__ + "assets/cb7edc60cdb2c8059b2315fe47f98856.svg";
export { SvgCr as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/cr.svg